export const SHELL_PORTAL = { PRACTICE: 'practice', ADMIN: 'admin' };
